<div mat-dialog-content>
    <p *ngIf="data.headerText" class="dialog-paragraph">{{ data.headerText }}</p>
    <ng-container
      [ngTemplateOutlet]="data.template"
      [ngTemplateOutletContext]="data.context"
    ></ng-container>
</div>